import { render, staticRenderFns } from "./DiagnosticHistoryPrint.vue?vue&type=template&id=13744c5a&"
import script from "./DiagnosticHistoryPrint.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHistoryPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports